"use client"

import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react'
import Image from 'next/image'
import { BsTwitterX } from 'react-icons/bs'
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa'

const socialLinks = [
  { icon: BsTwitterX, href: "https://x.com/ConceevDigital" },
  { icon: Facebook, href: "https://www.facebook.com/ConceevDigital" },
  { icon: FaYoutube, href: "https://www.youtube.com/@conceevdigital" },
  { icon: FaInstagram, href: "https://www.instagram.com/conceevdigital/" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/conceevdigital/" },
  { icon: Mail, href: "mailto:info@conceevdigital.com", isEmail: true },
]

export default function Footer() {
  return (
    <footer className="bg-[#191717] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-start align-items-center">
          {/* Logo Section */}
          <div className="flex flex-col items-center md:items-start">
            <Image src="/footer-logo.svg" alt="Conceev Digital" width={250} height={70} className='mt-4' />
            <p className='text-white text-sm min-w-18  p-4'>Unit of Conceev Medical Technologies (OPC) Private Limited</p>
          </div>

          {/* Address Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold mb-4 w-full sm:text-left">Our Office</h3>
            <div className="flex items-start space-x-2 text-sm text-gray-400">
              <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
              <p>
                No:61, Sri Sadan, 1st Floor, 6th Cross, 27th Main, l, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold mb-4  w-full sm:text-left">Contact Us</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <Phone className="w-5 h-5" />
                <a href="tel:+918009009707" className="hover:text-white transition-colors">
                  +91 80090 09707
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-5 h-5" />
                <a href="mailto:info@conceevdigital.com" className="hover:text-white transition-colors">
                  info@conceevdigital.com
                </a>
              </div>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold mb-4  w-full sm:text-left">Follow Us</h3>
            <div className="flex space-x-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className={`text-gray-400 hover:text-white transition-colors`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <link.icon className="w-6 h-6" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p className="text-sm text-gray-600 mx-auto w-full text-center">
            Copyright@ 2024 | All rights reserved by Conceev Digital - <a href="/privacy-policy" className="hover:text-[#c40234]">Privacy Policy</a> |
            <a href="/terms-and-condition" className="hover:text-[#c40234]">Terms & Conditions</a> |
            <a href="/disclaimer" className="hover:text-[#c40234]">Disclaimer</a> | <a href="/refund-policy" className="hover:text-[#c40234]">Refund Policy</a>
          </p>
        </div>
      </div>
    </footer>
  )
}

